<template>
  <!--  -->
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
    <div class="bg-white w-full rounded-lg shadow pb-2">
      <div id="noShow" class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex w-full">
          <button :class="$colors.primary" class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()">
            <i class="material-icons">chevron_left</i>
          </button>

          <div class="text-xl font-bold text-green-700">{{ $t('payement_details') }}</div>
        </div>
      </div>

      <div class="p-10" id="detailP"
        style="border: 2px solid #686565 !important; border-radius: 10px; padding: 11px; margin: 12px;padding-top: 8px; ">
        <div id="noShow" class="flex justify-between mb-4 no-display">
          <h2 class="text-2xl font-bold mb-6 pb-2 tracking-wider uppercase"></h2>
          <div class="relative mr-4 inline-block">
            <div
              class="text-gray-800 cursor-pointer w-10 h-10 rounded-full bg-gray-300 hover:bg-gray-300 inline-flex items-center justify-center"
              @click="openPopup"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"
                class="icon icon-tabler icon-tabler-printer">
                <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
                <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"></path>
                <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"></path>
                <rect x="7" y="13" width="10" height="8" rx="2"></rect>
              </svg></div>
            <div x-show.transition="showTooltip"
              class="z-40 shadow-lg text-center w-32 block absolute right-0 top-0 p-2 mt-12 rounded-lg bg-gray-800 text-white text-xs"
              style="display: none;"> Print this invoice! </div>
          </div>
        </div>
        <div class="invoice" style="display: flex;">
          <div class="invoice-title"
            style="color: #999; font-size: 1.875rem; line-height: 2.25rem; margin-bottom: 0; font-weight: 700; text-transform: uppercase;">
            Invoice <span>#{{ formData.id }}</span></div>
          <div class="invoice-des" style="text-align: right; margin-left: auto;">
            <img style="margin-left: auto; width: 10.5rem; height: auto; display: block; vertical-align: middle;"
              alt="cod" src="https://storeno.b-cdn.net/eship/Logo.png"
              class="align-middle border-none invoice-logo">
          </div>
        </div>

        <section id="pdf-content" class="relative">
          <loading :active.sync="loading" :is-full-page="fullPage"></loading>
          <div class="flex space-x-3">
            <div class="flex justify-between w-full h-auto  rounded-lg">
              <div class="flex w-full">

                <div class="w-full space-y-2">
                  <!-- <div class="text-base mt-2 mb-2 font-semibold text-gray-700">
                        {{$t('payement_no')}} : <span>#{{formData.id}}</span>
                      </div> -->

                  <div class="text-sm text-gray-600" style="color: black; font-weight: 600;">
                    {{ $t('seller') }} :
                    <span v-if="formData.seller"
                      class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700">
                      {{ formData.seller.fullName || formData.seller.company }}
                    </span>
                  </div>
                  <div class="text-sm text-gray-600 capitalize" style="color: black; font-weight: 600;">
                    {{ $t('warehouses') }} :
                    <span v-if="formData.warehouses && formData.warehouses.length > 0"
                      class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700">
                      <span v-for="(war, j) in formData.country" :key="j">
                        {{ $f.getCountryNameByCode(options, war) }} <span v-if="j != formData.country.length - 1">, </span>
                      </span>
                    </span>
                    <span v-else
                      class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700">{{
                        formData.country ? $f.getCountryNameByCode(options, formData.country[0]):'' }}</span>
                  </div>
                  <div class="text-sm text-gray-600" style="color: black; font-weight: 600;">
                    {{ $t('payement_method') }} :

                    <span class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700">
                      {{ formData.method }}
                    </span>
                  </div>
                  <div class="text-sm text-gray-600" style="color: black; font-weight: 600;">
                    {{ $t('date_payement') }}:
                    <span class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700">
                      {{ $moment(formData.date).format('yyyy-MM-DD') }}
                    </span>
                  </div>
                  <div v-if="formData.intervalDate && formData.intervalDate.fromDate && formData.intervalDate.toDate"
                    class="text-sm text-gray-600" style="color: black; font-weight: 600;">
                    {{ $t('Periode') }}:
                    <span class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700">
                      [{{ $moment(formData.intervalDate.fromDate).format('yyyy-MM-DD') }} - {{
                        $moment(formData.intervalDate.toDate).format('yyyy-MM-DD')}}]
                    </span>
                  </div>
                  <div class="text-sm text-gray-600" style="color: black; font-weight: 600;">
                    Number of orders:
                    <span class="justify-center text-xs  p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700">
                      {{ formData.count }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Orders -->
          <div class="w-full">
            <div class="login-or">
              <hr class="hr-or"><span style="left: 41%;" class="span-or">Orders</span>
            </div>
          </div>
          <section
            style="border: 2px dashed rgb(104, 101, 101) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">

            <table v-for="(group, index) in dataGroupedByCountry" :key="index" class="w-full leading-normal mt-4"
              style="page-break-after: avoid; page-break-before: avoid;width: 100%; overflow: scroll;line-height: 1.5;">
              <caption style="background: #cdcdcd; font-weight: bold; font-size: 1.1em; margin-left: -1px;">{{
                $f.getCountryNameByCode(options, group.country) || $f.getCountryNameByCode(options, formData.country[0])}}
                <small>({{ group.count }} orders)</small></caption>
              <thead>
                <tr>
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                    # </th>
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                    {{ $t('order_id') }} </th>
                  <!-- <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"> {{$t('Country')}} </th> -->
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                    Product name </th>
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                    {{ $t('total_price') }}</th>
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                    {{ $t('confirmation_fees') }}</th>
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                    {{ $t('Upsell fees') }}</th>
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"
                    v-if="formData.details[0] && formData.details[0].fulfillement_fees_vat"> {{ $t('fulfillement_fees') }}
                  </th>
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"
                    v-if="formData.country == 'MA'"> {{ $t('city') }}</th>
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                    {{ $t('shipping_fees') }}</th>
                  <!--  <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">  {{$t('refund_fees')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider"> {{$t('cancellation_fees')}}</th>
                        <th  style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;" class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider" v-if="formData.details[0] && formData.details[0].quality_control!=0"> {{$t('quality_control')}}</th>-->
                  <th
                    style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                    class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                    {{ $t('total') }}</th>
                </tr>
              </thead>
              <tbody v-for="(item, index) in group.orders" :key="item._id">
                <tr 
                  style="background-color: #f7fafc;border-style: solid;border-color: #e2e8f0;display: table-row;vertical-align: inherit;"
                  :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                  <td
                    :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'color: black;':''">
                      <span class="font-semibold">{{ index + 1 }}</span>
                    </p>
                  </td>
                  <td
                    :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'color: black;':''">
                      <span class="font-semibold">{{ item.order.id }}
                      </span>
                    </p>
                  </td>
                  <!-- <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;" 
                          class="px-2 py-1 border-b border-gray-200   bg-white text-xs"
                        >
                          <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                            <span class="font-semibold">{{  $f.getCountryNameByCode(options,item.country)||$f.getCountryNameByCode(options,formData.country[0])}}</span>
                          </p>
                        </td> -->
                  <td
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'color: black;':''">
                      <span class="font-semibold">{{ item.order.details && item.order.details[0] &&
                        item.order.details[0].name ? ProductNameSplit(item.order.details):item.products||'' }}</span>
                      <!-- <span class="font-semibold">{{ item.products||'' }}</span> -->
                    </p>
                  </td>
                  <td
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'color: black;':''">
                      <span class="font-semibold">{{ (item.shipping_refund_vat != 0 || item.shipping_cancel_vat != 0) ? 0 :item.order.totalPrice }} 
                        <small style="padding-left:2px" v-if="item.affiliate && item.affiliate.type">(Order Affiliate)</small>
                        <small style="padding-left:2px" v-if="item.POD && item.POD.name">(Order POD)</small>
                      </span>
                    </p>
                  </td>
                  <td :class="[item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'empty-row':'']"
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.confirmation_vat }}
                      </span>
                    </p>
                  </td>
                  <td :class="[item.upsell_vat ? '' : 'empty-row',item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'empty-row':'']"
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.upsell_vat || '' }}
                      </span>
                    </p>
                  </td>
                  <td :class="[item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'empty-row':'']"
                   :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    v-if="formData.details[0] && formData.details[0].fulfillement_fees_vat != 0"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.fulfillement_fees_vat }}
                      </span>
                    </p>
                  </td>
                  <td
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    v-if="formData.country == 'MA'" class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.order.customer.city }}
                      </span>
                    </p>
                  </td>
                  <td :class="[item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'empty-row':'']"
                    :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                      <span class="font-semibold">{{ item.shipping_vat }}
                      </span>
                    </p>
                  </td>

                  <!-- <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  :class="item.shipping_refund_vat==0?'empty-row':''" class="px-2 py-1 border-b border-gray-200   bg-white text-xs"><p style="margin: 0;" class="text-gray-700 whitespace-no-wrap"><span class="font-semibold">{{ item.shipping_refund_vat==0?'':item.shipping_refund_vat }} </span></p></td>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  :class="item.shipping_cancel_vat==0?'empty-row':''"  class="px-2 py-1 border-b border-gray-200   bg-white text-xs"><p style="margin: 0;" class="text-gray-700 whitespace-no-wrap"><span class="font-semibold">{{ item.shipping_cancel_vat==0?'':item.shipping_cancel_vat  }} </span></p></td>
                        <td  style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"  v-if="formData.details[0] && formData.details[0].quality_control!=0" class="px-2 py-1 border-b border-gray-200   bg-white text-xs"><p style="margin: 0;" class="text-gray-700 whitespace-no-wrap"><span class="font-semibold">{{ item.quality_control==0?'':item.quality_control  }} </span></p></td>-->
                  <td
                     :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'background-color: #1ba79e;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;':'padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;'"
                    class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                    <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap" :style="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)?'color: black;':''">
                      <span class="font-semibold">{{ item.amount }} <small style="padding-left:5px" v-if="item.affiliate && item.affiliate.type || (item.POD && item.POD.name)">(Commission)</small> </span>
                    </p>
                  </td>
                </tr>
                    </tbody>
              <tbody v-if="dataGroupedByCountry.length > 1">
                <tr>
                  <td
                    style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                    class="text-right text-sm text-gray-600 no-border" colspan="6"><span contenteditable="">Sales</span>
                  </td>
                  <td
                    style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                    class="text-right text-sm text-gray-700 no-border" colspan="2">
                    <span>{{ group.sales.toFixed(2) }}</span> <sup>{{ group.currency }}</sup></td>
                </tr>
                <tr>
                  <td
                    style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                    class="text-right text-sm text-gray-600 no-border" colspan="6"><span contenteditable="">Fees</span>
                  </td>
                  <td
                    style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                    class="text-right text-sm text-gray-700 no-border" colspan="2">
                    <span>{{ group.fees.toFixed(2) }}</span> <sup>{{ group.currency }}</sup></td>
                </tr>
                <tr>
                  <td
                    style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                    class="text-right text-sm text-gray-600 no-border" colspan="6"><span
                      contenteditable="">Amount</span></td>
                  <td
                    style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                    class="text-right text-sm text-gray-700 no-border" colspan="2">
                    <span>{{ group.amount.toFixed(2) }}</span> <sup>{{ group.currency }}</sup></td>
                </tr>
                <tr>
                  <td
                    style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                    class="text-right text-sm text-gray-600 no-border" colspan="6"><span contenteditable=""><svg
                        class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24">
                        <path
                          d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
                      </svg></span></td>
                  <td
                    style="font-weight: bold;font-size: 14px;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                    class="text-right text-sm text-gray-700 no-border" colspan="2">
                    <span>{{ (group.amount / formData.infoCurrency.find(o => o.currencyName ===
                      group.currency).currency).toFixed(2)}}</span> <sup>MAD</sup></td>
                </tr>
              </tbody>
            </table>
          </section>

          <div
            v-if="dataGroupedRefundsByCountry.length > 0 || dataGroupedExpeditionsByCountry.length > 0 || dataGroupedChargesByCountry.length > 0"
            class="w-full">
            <div class="login-or">
              <hr class="hr-or"><span style="left: 42%;" class="span-or">Credits</span>
            </div>
          </div>
          <section
            v-if="dataGroupedRefundsByCountry.length > 0 || dataGroupedExpeditionsByCountry.length > 0 || dataGroupedChargesByCountry.length > 0"
            style="border: 2px dashed rgb(232 3 3) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">
            <!-- Remboursements -->
            <section v-if="dataGroupedRefundsByCountry.length > 0"
              style="border: 2px solid rgb(232 3 3) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">
              <!-- <div v-if="dataGroupedRefundsByCountry.length>0" class="w-full"><div class="login-or"><hr class="hr-or"><span style="left: 42%;"  class="span-or">Remboursements ({{formData.refunds.length}})</span></div></div> -->

              <table class="w-full leading-normal"
                style="page-break-after: avoid; page-break-before: avoid;width: 100%; overflow: scroll;line-height: 1.5;">
                <caption style="background: rgb(226 118 118); font-weight: bold; font-size: 1.1em; margin-left: -1px;">
                  <small>({{ formData.refunds.length }} Remboursements)</small></caption>
                <thead>
                  <tr>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      #</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      {{ $t('warehouse') }}</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      ORDER_ID</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      {{ $t('customer') }}</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      {{ $t('date') }}</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      {{ $t('traking_number') }}</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      {{ $t('details') }}</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      {{ $t('total_price') }}</th>

                  </tr>
                </thead>
                <tbody v-for="(item, index) in formData.refunds" :key="item._id">
                  <tr
                    style="background-color: #f7fafc;border-style: solid;border-color: #e2e8f0;display: table-row;vertical-align: inherit;"
                    :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                        <span class="font-semibold">{{ index + 1 }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                        <span class="font-semibold">{{ $f.getCountryNameByCode(options, item.country) }}</span>
                      </p>
                    </td>

                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.shipping.orderObjet.id }}
                        </span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <div class="leading-5 text-blue-900 capitalize" v-if="item.shipping.orderObjet">
                        {{ item.shipping.orderObjet.customer.fullName }}</div>
                      <div v-if="item.shipping.orderObjet.customer" class="font-light text-gray-700 text-smm">
                        {{ item.shipping.orderObjet.customer.phone }}</div>

                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ $moment(item.shipping.date).format('yyyy-MM-DD') }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.shipping.trackingNumber }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.shipping.orderObjet.details.length }} Products
                        </span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.fees_amount }} <sup>{{ item.currency }}</sup>
                        </span>
                      </p>
                    </td>

                  </tr>
                </tbody>

                <tbody v-if="dataGroupedRefundsByCountry.length > 1">

                  <tr>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-600 no-border" colspan="5"><span
                        contenteditable="">Fees</span></td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-700 no-border" colspan="3">
                      <!-- <span>{{group.fees.toFixed(2)}}</span> <sup>{{group.currency}}</sup> -->
                      <span v-for="(price, j) in formData.amountRefundsCurrency" :key="j">
                        {{ price.fees_amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                          v-if="j != formData.amountRefundsCurrency.length - 1">|</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-600 no-border" colspan="5"><span contenteditable=""><svg
                          class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                          viewBox="0 0 24 24">
                          <path
                            d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
                        </svg></span></td>
                    <td
                      style="font-weight: bold;font-size: 14px;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-700 no-border" colspan="3">
                      <!-- <span>{{(group.fees/formData.infoCurrency.find(o => o.currencyName === group.currency).currency).toFixed(2)}}</span> <sup>MAD</sup> -->
                      {{ Math.round(formData.amountCurrency.map(item => item.fees_refoundMad).reduce((prev, next) =>
                      prev + next) )}} <sup>MAD</sup>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
            <!-- Expedition -->
            <section v-if="dataGroupedExpeditionsByCountry.length > 0"
              style="border: 2px solid rgb(232 3 3) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">
              <!-- <div v-if="dataGroupedExpeditionsByCountry.length>0" class="w-full"><div class="login-or"><hr class="hr-or"><span style="left: 42%;"  class="span-or">Expeditions</span></div></div> -->

              <table class="w-full leading-normal"
                style="page-break-after: avoid; page-break-before: avoid;width: 100%; overflow: scroll;line-height: 1.5;">
                <caption style="background: rgb(226 118 118); font-weight: bold; font-size: 1.1em; margin-left: -1px;">
                  <small>({{ formData.expeditions.length }} Expeditions)</small></caption>
                <thead>
                  <tr>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      #</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      {{ $t('warehouse') }}</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      ID</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      WEIGHT (KG) </th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      Number Of Packages</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      RECEPTION DATE</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      PRODUCTS</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      FRAIS RECUPERATION COLIS</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      FROM</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      EXPEDITION FEES</th>
                    <th id="noShow" v-if="!idP && formData && formData._id && getAccess('payments', 'create')"
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      ACTION</th>
                  </tr>
                </thead>
                <tbody v-for="(item, index) in formData.expeditions" :key="item._id">
                  <tr
                    style="background-color: #f7fafc;border-style: solid;border-color: #e2e8f0;display: table-row;vertical-align: inherit;"
                    :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                        <span class="font-semibold">{{ index + 1 }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                        <span class="font-semibold">{{ $f.getCountryNameByCode(options, item.country) }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.id.id }}
                        </span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.id.type && item.id.type === 'transfer' ? '' : item.id.weight ||
                          0 }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.id.type && item.id.type ===
                          'transfer' ? item.id.numberOfPackages || 0 :'' }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ $moment(item.id.arrivalDate).format('yyyy-MM-DD') }}</span>
                      </p>
                    </td>
                    <td
                      style="width: 30px; overflow: hidden; display: inline-block; white-space: nowrap;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span v-html="ProductGroupNmae(item.id, item.currency)" class="font-semibold"></span>
                      </p>
                    </td>

                    <td
                      style="width: 30px; overflow: hidden; display: inline-block; white-space: nowrap;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap font-semibold">
                        {{ item.id.details && item.id.details.length > 0 ? item.id.details.reduce((n,
                          { frais_recuperation_colis }) => n + frais_recuperation_colis||0, 0):0 }} <sup>{{ item.currency
                          }}</sup>
                      </p>
                    </td>

                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ $f.getCountryNameByCode(optionsCountries, item.id.country) }}
                        </span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.fees_amount }} <sup>{{ item.currency }}</sup>
                        </span>
                      </p>
                    </td>
                    <td id="noShow" v-if="!idP && formData && formData._id && getAccess('payments', 'create')"
                      class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">

                      <button @click="remove('expeditions', item.id._id)" :class="loadingRemove ? 'noselect' : ''"
                        :disabled="loadingRemove"
                        class="rounded-full flex items-center focus:outline-none w-8 h-8 mr-3 mt-1 relative loidingconfirm">
                        <loading v-if="dataChange.index && dataChange.index.toString() === item.id._id.toString()"
                          :active.sync="loadingRemove" :is-full-page="fullPage"></loading> <i
                          class="material-icons mx-1">delete</i>
                      </button>

                    </td>
                  </tr>
                </tbody>

                <tbody v-if="dataGroupedExpeditionsByCountry.length > 1">

                  <tr>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-600 no-border" colspan="7"><span
                        contenteditable="">Fees</span></td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-700 no-border" colspan="3">
                      <!-- <span>{{group.fees.toFixed(2)}}</span> <sup>{{group.currency}}</sup> -->
                      <span v-for="(price, j) in formData.amountExpeditionsCurrency" :key="j">
                        {{ price.fees_amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                          v-if="j != formData.amountExpeditionsCurrency.length - 1">|</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-600 no-border" colspan="7"><span contenteditable=""><svg
                          class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                          viewBox="0 0 24 24">
                          <path
                            d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
                        </svg></span></td>
                    <td
                      style="font-weight: bold;font-size: 14px;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-700 no-border" colspan="3">
                      <!-- <span>{{(group.fees/(formData.infoCurrency.find(o => o.currencyName === group.currency).currencyCredit||formData.infoCurrency.find(o => o.currencyName === group.currency).currency)).toFixed(2)}}</span> <sup>MAD</sup> -->
                      {{ Math.round(formData.amountCurrency.map(item => item.fees_expeditionMad).reduce((prev, next) =>
                      prev + next) )}} <sup>MAD</sup>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
            <!-- Charges -->
            <section v-if="dataGroupedChargesByCountry.length > 0"
              style="border: 2px solid rgb(232 3 3) !important;border-radius: 10px;padding: 5px;margin-top: 10px;">
              <!-- <div v-if="dataGroupedChargesByCountry.length>0" class="w-full"><div class="login-or"><hr class="hr-or"><span style="left: 43%;"  class="span-or">Charges</span></div></div> -->

              <table class="w-full leading-normal"
                style="page-break-after: avoid; page-break-before: avoid;width: 100%; overflow: scroll;line-height: 1.5;">
                <caption style="background: rgb(226 118 118); font-weight: bold; font-size: 1.1em; margin-left: -1px;">
                  <small>({{ formData.charges.length }} Charges)</small></caption>
                <thead>
                  <tr>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      #</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-left  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      {{ $t('warehouse') }}</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      ID</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      colspan="4"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      COMMENT</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      DATE</th>
                    <th
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      AMOUNT</th>
                    <th id="noShow" v-if="!idP && formData && formData._id && getAccess('payments', 'create')"
                      style="letter-spacing: 0.05em;text-transform: capitalize;text-align: left;padding-left: 0.75rem;padding-right: 0.75rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;font-weight: 600;border-bottom-width: 2px;border-color: #edf2f7;border-style: solid;"
                      class="px-3 py-1 text-center  border-b-2 border-gray-200 text-left text-xs font-semibold text-green-700 bg-green-200 capitalize tracking-wider">
                      ACTION</th>
                  </tr>
                </thead>
                <tbody v-for="(item, index) in formData.charges" :key="item._id">
                  <tr
                    style="background-color: #f7fafc;border-style: solid;border-color: #e2e8f0;display: table-row;vertical-align: inherit;"
                    :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                        <span class="font-semibold">{{ index + 1 }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-3 py-1 text-left border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700  whitespace-no-wrap">
                        <span class="font-semibold">{{ $f.getCountryNameByCode(options, item.country) }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.id.id }}
                        </span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      colspan="4" class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.id.comment }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ $moment(item.id.date).format('yyyy-MM-DD') }}</span>
                      </p>
                    </td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="px-2 py-1 border-b border-gray-200   bg-white text-xs">
                      <p style="margin: 0;" class="text-gray-700 whitespace-no-wrap">
                        <span class="font-semibold">{{ item.fees_amount }} <sup>{{ item.currency }}</sup>
                        </span>
                      </p>
                    </td>
                    <td id="noShow" v-if="!idP && formData && formData._id && getAccess('payments', 'create')"
                      class="px-6 py-2 whitespace-no-wrap border-b border-gray-200">

                      <button @click="remove('charges', item.id._id)" :class="loadingRemove ? 'noselect' : ''"
                        :disabled="loadingRemove"
                        class="rounded-full flex items-center focus:outline-none w-8 h-8 mr-3 mt-1 relative loidingconfirm">
                        <loading v-if="dataChange.index && dataChange.index.toString() === item.id._id.toString()"
                          :active.sync="loadingRemove" :is-full-page="fullPage"></loading> <i
                          class="material-icons mx-1">delete</i>
                      </button>

                    </td>
                  </tr>
                </tbody>

                <tbody v-if="dataGroupedChargesByCountry.length > 1">

                  <tr>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-600 no-border" colspan="7"><span
                        contenteditable="">Fees</span></td>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-700 no-border" colspan="3">
                      <!-- <span>{{group.fees.toFixed(2)}}</span> <sup>{{group.currency}}</sup> -->
                      <span v-for="(price, j) in formData.amountChargesCurrency" :key="j">
                        {{ price.fees_amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                          v-if="j != formData.amountChargesCurrency.length - 1">|</span>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-600 no-border" colspan="7"><span contenteditable=""><svg
                          class="fill-current  float-right" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                          viewBox="0 0 24 24">
                          <path
                            d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
                        </svg></span></td>
                    <td
                      style="font-weight: bold;font-size: 14px;padding-left: 0.5rem;padding-right: 0.5rem;padding-top: 0.25rem;padding-bottom: 0.25rem;font-size: 0.75rem;border-bottom-width: 1px;border-color: #edf2f7;border-style: solid;    display: table-cell;vertical-align: inherit;"
                      class="text-right text-sm text-gray-700 no-border" colspan="3">
                      <!-- <span>{{(group.fees/(formData.infoCurrency.find(o => o.currencyName === group.currency).currencyCredit||formData.infoCurrency.find(o => o.currencyName === group.currency).currency)).toFixed(2)}}</span> <sup>MAD</sup> -->
                      {{ Math.round(formData.amountCurrency.map(item => item.fees_chargeMad).reduce((prev, next) => prev
                      + next) )}} <sup>MAD</sup>
                    </td>
                  </tr>
                </tbody>
              </table>
            </section>
          </section>

          <div class="py-2 ml-auto mt-5 w-full sm:w-4/5"
            :style="dataGroupedByCountry.length > 1 ? 'border-top: 2px solid black;width: 80%;padding-top: 0.5rem;padding-bottom: 0.5rem;margin-left: auto;' : 'width: 80%;padding-top: 0.5rem;padding-bottom: 0.5rem;margin-left: auto;'">
            <div class="flex justify-between mb-2"
              style="margin-bottom: 9px;justify-content: space-between;display: flex;">
              <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">Total
                Sales:</div>
              <div class="text-right w-40" style="width: 50%;text-align: right;">
                <div
                  v-if="formData.amountCurrency && formData.infoCurrency && formData.infoCurrency.length > 0 && formData.amountCurrency.length > 0"
                  class="text-gray-800 font-medium">
                  <span v-for="(price, j) in formData.amountCurrency" :key="j">
                    {{ price.totalPrice.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                      v-if="j != formData.amountCurrency.length - 1">|</span>
                  </span>
                </div>
                <div v-else class="text-gray-800 font-medium">{{ totalSales }} <sup v-if="idWharhouse">{{
                    idWharhouse.currency}}</sup></div>
              </div>
            </div>
            <div class="flex justify-between mb-2"
              style="margin-bottom: 9px;justify-content: space-between;display: flex;">
              <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">Total
                Fees:</div>
              <div class="text-right w-40" style="width: 50%;text-align: right;">
                <div
                  v-if="formData.amountCurrency && formData.infoCurrency && formData.infoCurrency.length > 0 && formData.amountCurrency.length > 0"
                  class="text-gray-800 font-medium">
                  <span v-for="(price, j) in formData.amountCurrency" :key="j">
                    {{ price.fees.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                      v-if="j != formData.amountCurrency.length - 1">|</span>
                  </span>
                </div>
                <div v-else class="text-gray-800 font-medium">{{ totalFees }} <sup v-if="idWharhouse">{{
                    idWharhouse.currency}}</sup></div>
              </div>
            </div>

            <template
              v-if="formData.amountCurrency && formData.infoCurrency && formData.infoCurrency.length > 0 && formData.amountCurrency.length > 0 && (formData.amountRefundsCurrency.length != 0 || formData.amountExpeditionsCurrency.length != 0 || formData.amountChargesCurrency.length != 0)">
              <div class="flex justify-between mb-2 border-t"
                style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                <div class="text-gray-800 text-right flex-1"
                  style="text-align: right;width: 50%;color: #2d3748;font-weight: 700;">Profit Net:</div>
                <div class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-gray-800 font-medium">
                    <span v-for="(price, j) in formData.amountCurrency" :key="j">
                      {{ (price.totalPrice - price.fees) }} <sup>{{ price.currency }}</sup> <span
                        v-if="j != formData.amountCurrency.length - 1">|</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex justify-between">
                <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path
                      d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
                  </svg></div>
                <div class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-xl text-gray-800 font-bold">
                    {{ Math.round(formData.amountCurrency.map(item => item.amountSales_FeesMad).reduce((prev, next) =>
                    prev + next) )}} <sup>MAD</sup>
                  </div>
                </div>
              </div>
            </template>

            <template
              v-if="formData.amountRefundsCurrency && formData.infoCurrency && formData.infoCurrency.length > 0 && formData.amountRefundsCurrency.length > 0">
              <div class="flex justify-between mb-2 border-t"
                style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">
                  Remboursements Fees <small>({{ formData.refunds.length }} orders)</small>:</div>
                <div class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-gray-800 font-medium">
                    <span v-for="(price, j) in formData.amountRefundsCurrency" :key="j">
                      {{ price.fees_amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                        v-if="j != formData.amountRefundsCurrency.length - 1">|</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex justify-between">
                <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path
                      d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
                  </svg></div>
                <div class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-xl text-gray-800 font-bold">
                    {{ Math.round(formData.amountCurrency.map(item => item.fees_refoundMad).reduce((prev, next) => prev
                    + next) )}} <sup>MAD</sup>
                  </div>
                </div>
              </div>
            </template>

            <template
              v-if="formData.amountExpeditionsCurrency && formData.infoCurrency && formData.infoCurrency.length > 0 && formData.amountExpeditionsCurrency.length > 0">
              <div class="flex justify-between mb-2 border-t"
                style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">
                  Expeditions Fees <small>({{ formData.expeditions.length }} expeditions)</small>:</div>
                <div class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-gray-800 font-medium">
                    <span v-for="(price, j) in formData.amountExpeditionsCurrency" :key="j">
                      {{ price.fees_amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                        v-if="j != formData.amountExpeditionsCurrency.length - 1">|</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex justify-between">
                <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path
                      d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
                  </svg></div>
                <div class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-xl text-gray-800 font-bold">
                    {{ Math.round(formData.amountCurrency.map(item => item.fees_expeditionMad).reduce((prev, next) =>
                    prev + next) )}} <sup>MAD</sup>
                  </div>
                </div>
              </div>
            </template>

            <template
              v-if="formData.amountChargesCurrency && formData.infoCurrency && formData.infoCurrency.length > 0 && formData.amountChargesCurrency.length > 0">
              <div class="flex justify-between mb-2 border-t"
                style="margin-bottom: 9px;justify-content: space-between;display: flex;">
                <div class="text-gray-800 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">
                  Charges Fees <small>({{ formData.charges.length }} charges)</small>:</div>
                <div class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-gray-800 font-medium">
                    <span v-for="(price, j) in formData.amountChargesCurrency" :key="j">
                      {{ price.fees_amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                        v-if="j != formData.amountChargesCurrency.length - 1">|</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="flex justify-between">
                <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path
                      d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
                  </svg></div>
                <div class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-xl text-gray-800 font-bold">
                    {{ Math.round(formData.amountCurrency.map(item => item.fees_chargeMad).reduce((prev, next) => prev +
                    next) )}} <sup>MAD</sup>
                  </div>
                </div>
              </div>
            </template>


            <div v-if="formData.vat" class="flex justify-between mb-4"
              style="margin-bottom: 0.80rem;justify-content: space-between;display: flex;">
              <div class="text-sm text-gray-600 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">
                TVA
                ({{ formData.vat }}%)</div>
              <div class="text-right w-40" style="width: 50%;text-align: right;">
                <div class="text-sm text-gray-600" style="color: black; font-weight: 600;">{{ formData.vatFees }} <sup
                    v-if="idWharhouse">{{ idWharhouse.currency }}</sup></div>
              </div>
            </div>
            <div v-if="formData.transfert_fees" class="flex justify-between mb-4"
              style="margin-bottom: 0.80rem;justify-content: space-between;display: flex;">
              <div class="text-sm text-gray-600 text-right flex-1" style="text-align: right;width: 50%;color: #2d3748;">
                Transfert
                Fees</div>
              <div class="text-right w-40" style="width: 50%;text-align: right;">
                <div class="text-sm text-gray-600" style="color: black; font-weight: 600;">{{ formData.transfert_fees }}
                  <sup v-if="idWharhouse">{{ idWharhouse.currency }}</sup></div>
              </div>
            </div>

            <div class="py-2 border-t border-b">
              <div class="flex justify-between" style="justify-content: space-between;display: flex;">
                <div class="text-gray-600 text-right flex-1"
                  style="text-align: right;width: 50%;color: #2d3748;font-weight: 800;">
                  Payment net:</div>

                <div
                  v-if="formData.amountCurrency && formData.infoCurrency && formData.infoCurrency.length > 0 && formData.amountCurrency.length > 0"
                  class="text-right w-40" style="width: 50%;text-align: right;">
                  <span v-for="(price, j) in formData.amountCurrency" :key="j">
                    {{ price.amount.toFixed(2) }} <sup>{{ price.currency }}</sup> <span
                      v-if="j != formData.amountCurrency.length - 1">|</span>
                  </span>
                </div>
                <div v-else class="text-right w-40" style="width: 50%;text-align: right;">{{ total.toFixed(2) }} <sup
                    v-if="idWharhouse">{{ idWharhouse.currency }}</sup></div>
              </div>
              <div class="flex justify-between">
                <div class="text-xl text-gray-600 text-right flex-1"><svg class="fill-current  float-right"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path
                      d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
                  </svg></div>
                <div
                  v-if="formData.amountCurrency && formData.infoCurrency && formData.infoCurrency.length > 0 && formData.amountCurrency.length > 0"
                  class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-xl text-gray-800 font-bold">

                    <!-- {{formData.amountCurrency.map(item => {
                                  const objC = formData.infoCurrency.find(o => o.currencyName === item.currency); 
                                  return item.amount/objC.currency;
                              }).reduce((prev, curr) => prev + curr, 0).toFixed(2)}}  -->

                    {{ Math.round(formData.amountCurrency.map(item => item.amountMad).reduce((prev, next) => prev +
                    next) )}}
                    <sup>MAD</sup>

                  </div>
                </div>
                <div v-else class="text-right w-40" style="width: 50%;text-align: right;">
                  <div class="text-xl text-gray-800 font-bold" v-if="formData.info">{{
                    (total / formData.info.currency).toFixed(2)}}
                    <sup>MAD</sup>
                  </div>
                </div>

              </div>
            </div>
          </div>





          <!--Modal New courier Shipping -->
          <vue-modal-2 class="no-display" name="nameInvoice" :headerOptions="{ title: 'Payement Info' }" :noFooter="true"
            modalSize="lg" @on-close="close">
            <div class="bg-white rounded-lg">
              <div class="rounded-lg flex">
                <div class="w-1/4 flex justify-center items-center">
                  <span class="w-16 h-16 bg-blue-600 text-white p-3 rounded-full"><i class="material-icons"
                      style="font-size: 40px;">file_download</i></span>
                </div>
                <div class="w-full pr-4 mt-4">
                  <div class="grid grid-cols-1">
                    <div
                      class="border hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                      <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                        <p>
                          <label for="fullname" class="bg-white text-gray-700 px-1">Invoice Name <span
                              :class="$colors.required">*</span></label>
                        </p>
                      </div>
                      <p>
                        <input type="text" v-model="InvoiceName"
                          class="py-2 text-xs px-2 outline-none block h-full w-full">
                      </p>
                    </div>
                  </div>

                </div>
              </div>
              <div class="p-4 flex space-x-4">
                <a href="#" @click="close"
                  class="w-1/2 px-4 py-3 text-center bg-gray-500 text-white hover:bg-gray-400  font-bold rounded-lg text-sm">Cancel</a>
                <a href="#" @click="generateReport"
                  class="w-1/2 px-4 py-3 text-center text-blue-100 bg-blue-600 rounded-lg hover:bg-blue-700 hover:text-white font-bold text-sm">Confirme</a>
              </div>
            </div>
          </vue-modal-2>
          <!-- end  New courier  shipping -->




        </section>
      </div>
    </div>

  </div>
  <!--  -->
</template>

<script>
import jsPDFInvoiceTemplate, { OutputType, jsPDF } from "jspdf-invoice-template";
import image from "@/assets/CODINAFRICA.png";

//or directly in browser
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
    idPayment: { type: String },
  },
  data() {
    return {
      formData: {
        details: [],
      },
      expeditionCount: 0,
      InvoiceName: "",
      image: image,
      fullPage: false,
      loading: false,
      content: [],
      headers: [{ title: this.$t('order_id') }, { title: this.$t('country') }, { title: this.$t('products') }, { title: this.$t('total_price') }, { title: this.$t('confirmation') }, { title: this.$t('shipping') }, { title: this.$t('fulfillement') }, { title: this.$t('total') }],
      total: 0,
      totalFees: 0,
      totalSales: 0,
      options: this.$countries,
      currency: "",
      invoiceData: {},
      dataGroupedByCountry: [],
      dataGroupedExpeditionsByCountry: [],
      dataGroupedRefundsByCountry: [],
      dataGroupedChargesByCountry: [],
      dataProducts: [],
      optionsCountries: this.$countries,
      idP: this.idPayment,
      loadingRemove: false,
      dataChange: { index: null },
    };
  },
  watch: {
    'idPayment': async function () {
      this.idP = this.idPayment;
      await this.dataToEdit();
    },
  },
  async mounted() {
    await this.dataToEdit();
  },
  methods: {
    async remove(name, id) {
      this.$confirm(`Confirm delete ${name}`).then(
        async (res) => {
          if (res) {
            //chargeID
            this.dataChange.index = id;
            this.loadingRemove = true;
            const resp = await this.$server.update("payments", { _id: this.formData._id, creditID: id, type: name });
            this.loadingRemove = false;
            if (resp && resp._id) {
              alert('Payments updated', "success");
              this.dataChange.index = null;
              await this.dataToEdit();
            } else alert(resp, "warning");
          }
        }
      );
    },
    getAccess(modelToCheck, accessToCheck) {
      if (this.currentUser && this.currentUser.type) {
        const permissions = this.currentUser.role.permissions;
        for (let i in permissions) {
          let model = permissions[i]["model"];
          let access = permissions[i]["access"];

          if (model == modelToCheck) {
            return access[accessToCheck];
          }
        }
      } else return false;

    },
    ProductGroupNmae(data, currency) {
      let product = "";
      let typeExp = 'Prix de 1 kilo: ';
      if (data.type && data.type === 'transfer') typeExp = 'Prix de 1 colis: ';
      for (let i in data.details) {
        if (data.details[i].name) product += data.details[i].name + ` (<span style="text-decoration: underline overline limegreen double 1.2px;">${typeExp + data.details[i].price_one_kiloOrPackage} <sup>${currency}</sup>)</span>`;
        if (data.details.length - 1 != i) product += " | ";
      }
      return product;
    },
    getElementInArray(data, value) {
      var result = data.filter(function (o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null; // or undefined
    },
    sumObjAmountCurrency(objArr, infoCurrency = [], refunds = [], expeditions = [], charges = []) {
      var newArr = [];
      infoCurrency.forEach(row2 => {
        var index = objArr.findIndex(x => x.currency == row2.currencyName);
        if (index === -1) objArr.push({
          "count": 0,
          "currency": row2.currencyName,
          "country": row2.country,
          "totalPrice": 0,
          "amount": 0,
          "fees": 0
        })
      });

      expeditions.forEach(row => { row.type = 'expedition'; });
      charges.forEach(row => { row.type = 'charge'; });

      if (refunds.length > 0) objArr = objArr.concat(refunds);
      if (expeditions.length > 0) objArr = objArr.concat(expeditions);
      if (charges.length > 0) objArr = objArr.concat(charges);

      //amount by mad
      objArr.forEach(row => {
        row.amountSales_Fees = 0;
        row.amountSales_FeesMad = 0;
        row.amountMad = 0;
        row.fees_amountMad = 0;

        row.fees_refoundMad = 0;
        row.fees_expeditionMad = 0;
        row.fees_chargeMad = 0;

        if (!row.amount) row.amount = 0;
        if (!row.fees) row.fees = 0;
        if (!row.totalPrice) row.totalPrice = 0;
        if (!row.fees_amount) row.fees_amount = 0;

        const getCurrency = infoCurrency.find(o => o.currencyName === row.currency);
        if (getCurrency && row.type && ['expedition', 'charge'].indexOf(row.type) !== -1) {
          row.amountMad = row.amount / getCurrency.currencyCredit;
          row.fees_amountMad = row.fees_amount / getCurrency.currencyCredit;
          if (row.type === "expedition") row.fees_expeditionMad = row.fees_amount / getCurrency.currencyCredit;
          if (row.type === "charge") row.fees_chargeMad = row.fees_amount / getCurrency.currencyCredit;
        } else {
          row.amountMad = row.amount / getCurrency.currency;
          row.fees_amountMad = row.fees_amount / getCurrency.currency;
          row.amountSales_FeesMad = (row.totalPrice - row.fees) / getCurrency.currency;
          row.fees_refoundMad = row.fees_amount / getCurrency.currency;
        }
      });

      let result = objArr.reduce((acc, curr) => {
        let item = acc.find(item => item.currency === curr.currency);

        if (item) {

          if (!item.amountSales_Fees) item.amountSales_Fees = 0; if (!curr.amountSales_Fees) curr.amountSales_Fees = 0;
          if (!item.amount) item.amount = 0; if (!curr.amount) curr.amount = 0;
          if (!item.count) item.count = 0; if (!curr.count) curr.count = 0;
          if (!item.fees) item.fees = 0; if (!curr.fees) curr.fees = 0;
          if (!item.totalPrice) item.totalPrice = 0; if (!curr.totalPrice) curr.totalPrice = 0;
          if (!item.fees_amount) item.fees_amount = 0; if (!curr.fees_amount) curr.fees_amount = 0;

          if (!item.amountMad) item.amountMad = 0; if (!curr.amountMad) curr.amountMad = 0;
          if (!item.fees_amountMad) item.fees_amountMad = 0; if (!curr.fees_amountMad) curr.fees_amountMad = 0;
          if (!item.amountSales_FeesMad) item.amountSales_FeesMad = 0; if (!curr.amountSales_FeesMad) curr.amountSales_FeesMad = 0;

          if (!item.fees_refoundMad) item.fees_refoundMad = 0; if (!curr.fees_refoundMad) curr.fees_refoundMad = 0;
          if (!item.fees_expeditionMad) item.fees_expeditionMad = 0; if (!curr.fees_expeditionMad) curr.fees_expeditionMad = 0;
          if (!item.fees_chargeMad) item.fees_chargeMad = 0; if (!curr.fees_chargeMad) curr.fees_chargeMad = 0;

          item.amount += curr.amount;
          item.amountMad += curr.amountMad;
          item.count += curr.count;

          item.fees += curr.fees;
          item.totalPrice += curr.totalPrice;
          item.amountSales_Fees = item.totalPrice - item.fees;
          item.amountSales_Fees += curr.amountSales_Fees;
          item.amount -= curr.fees_amount;
          item.amountMad -= curr.fees_amountMad;


          item.fees_refoundMad += curr.fees_refoundMad;
          item.fees_expeditionMad += curr.fees_expeditionMad;
          item.fees_chargeMad += curr.fees_chargeMad;
          item.amountSales_FeesMad += curr.amountSales_FeesMad;

        } else {
          if (!curr.amountSales_Fees) curr.amountSales_Fees = 0;
          if (!curr.fees_expeditionMad) curr.fees_expeditionMad = 0;
          if (!curr.fees_refoundMad) curr.fees_refoundMad = 0;
          if (!curr.fees_chargeMad) curr.fees_chargeMad = 0;
          if (!curr.amount) curr.amount = 0;
          if (!curr.count) curr.count = 0;
          if (!curr.fees) curr.fees = 0;
          if (!curr.totalPrice) curr.totalPrice = 0;
          if (!curr.fees_amount) curr.fees_amount = 0;
          if (!curr.amountMad) curr.amountMad = 0;
          acc.push(curr);
        }

        return acc;
      }, []);
      return result;
    },
    RouterBack: function () {
      this.$router.back();
    },
    async sumProduct(data) {
      let product = "";
      for (let i in data) {
        const editData = await this.$server.get("products", { id: data[i].product, });
        product += editData.content.name
        if (data.length - 1 != i) product += " ,";
      }
      return product;
    },
    async getCurrency() {
      await this.$store.dispatch('wharhouse/getCurrency').then((res) => {
        this.currency = res;
      })
    },
    close() {
      this.$vm2.close('nameInvoice');
    },
    openPopup() {
      this.$vm2.open('nameInvoice');
    },
    async generateReport() {
      if (!this.InvoiceName) {
        alert("File name required", "warning");
        return false;
      }

      var mywindow = window.open('', 'PRINT', 'height=400,width=600');
      mywindow.document.write(`<html lang="en"><head><meta charset="utf-8"><title>${this.InvoiceName}</title>`);
      mywindow.document.write('<style type="text/css">.login-or { position: relative; color: rgb(0 0 0 / 55%); margin-top: 10px; margin-bottom: 10px; padding-top: 10px; padding-bottom: 10px; } .hr-or { height: 2px; margin-top: 0px !important; margin-bottom: 0px !important; border: 0; border-top: 2px solid rgb(0 0 0 / 55%); } .span-or { display: block; position: absolute; left: 47%; top: -2px; margin-left: -25px; background-color: #fff; width: 190px; text-align: center; font-weight: 700; }.text-xs { font-size: 0.75rem; }.font-semibold { font-weight: 600; }.text-center { text-align: center; } .pl-3 { padding-left: 0.75rem; }.pr-2 { padding-right: 0.5rem; } .p-1 { padding: 0.25rem; }#detailP{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";}.no-display{display: none !important;}.no-border{border: none;}.text-xs{font-size: 0.75rem;}.text-gray-600{color: #718096;}td {display: table-cell;vertical-align: inherit;}.text-green-700{color: #2f855a;}.invoice { display: flex; } .invoice-title { color: #999; font-size: 1.875rem; line-height: 2.25rem; margin-bottom: 0; font-weight: 700; text-transform: uppercase; } .invoice-des { text-align: right; margin-left: auto; } .invoice-logo{ margin-left: auto; width: 10.5rem; height: auto; display: block; vertical-align: middle; } caption { background: #cdcdcd; font-weight: bold; font-size: 1.1em; margin-left: -1px; /* Fix FF 1px issue */ } .w-40{ width: 25em; }.mb-6 { margin-bottom: 0.7rem; }.items-center{ align-items: center;} .align-items-center{ align-items: center !important; } .text-blue { color: #3182ce; } .row { display: flex; flex-wrap: wrap; } .text-sm-end { text-align: right; } .col-sm-5 { flex: 0 0 auto; width: 41.66666667%; } .text-sm-start { text-align: left; } .mb-sm-0 { margin-bottom: 0; } .mb-0 { margin-bottom: 0; } .mb-3 { margin-bottom: 1rem; } .imgg { vertical-align: inherit; width: 40px; display: inline-block; } .v-super{ vertical-align:super } .col-sm-7 { flex: 0 0 auto; width: 58.33333333%; } .h4 { font-size: 1.5rem; color: #0c2f54; } .p { line-height: 1.9; margin-top: 0; margin-bottom: 1rem; } .text-2xl { font-size: 1.5rem; } .pl-4 { padding-left: 1rem; } .border-l-2 { border-left-width: 2px !important;; border-color: #3182ce !important; } .mt-10{ margin-top: 10px; } .text-xss { font-size: 0.70rem !important; } .border-blue-600 { border-color: #3182ce; } .p-4 { padding: 1rem; } .mt-4 { margin-top: 1rem; } .tracking-wider { letter-spacing: 0.05em; } .text-gray-600 { color: #718096; } .text-left { text-align: left; } .text-blue-700 { color: #114f8f; } .px-6 { padding-left: 1.5rem; padding-right: 1.5rem; } .p-bb{ padding-bottom: 4px; } .py-3 { padding-top: 0.55rem; padding-bottom: 0.55rem; } .leading-4 { line-height: 1rem; } .border-b-2 { border-bottom-width: 2px; border-color: #e2e8f0 !important; } .border-t-2 { border-top-width: 2px; border-color: #e2e8f0 !important; } .border-gray-300 { border-color: #e2e8f0; } .bg-gray-200 { background-color: #edf2f7; } .h-auto { height: auto; } .bg-gray-100 { background-color: #f7fafc; } .border-dashed { border-style: dashed; } .border-gray-800 { border-color: #2d3748; } .text-xs { font-size: 0.55rem; } .font-semibold { font-weight: 600; } .dis-none{ display: none; } .text-gray-700 { color: #262728; } .rounded-full { border-radius: 9999px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-gray-200 { border-color: #8e9193; } tbody { display: table-row-group; vertical-align: middle; border-color: inherit; } tr { display: table-row; vertical-align: inherit; border-color: inherit; } .px-5 { padding-left: 1.10rem; padding-right: 1.10rem; } .width-40{ width: 50% !important; } .mb-3 { margin-bottom: 0.75rem; } sup { top: -0.5em; } .mt-10{ margin-bottom: 10px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-t { border-top-width: 1px; border-color: #e2e8f0 !important; } .text-xl { font-size: 1.25rem; } sub, sup { font-size: 75%; line-height: 0; position: relative; vertical-align: baseline; } .pt-4 { padding-top: 1rem; } .text-m { font-size: 18px; } .w-40 { width: 10rem; } .text-right { text-align: right; } .text-gray-900 { color: #1a202c; } .flex-1 { flex: 1 1 0%; } .py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; } .ml-auto { margin-left: auto; } .min-w-full { min-width: 100%; } .mt-5 { margin-top: 1.25rem; } table { display: table; border-collapse: collapse; box-sizing: border-box; text-indent: initial; border-spacing: 2px; border-color: grey; } .p-2 { padding: 0.5rem; } .ml-1 { margin-left: 0.25rem; } .overflow-visible{white-space: initial;}.trakingn img{width: 50%;}.mb-0{margin-bottom: 0px;}.w-1/4{width: 25%;}.w-3/4{width: 75%;}.m-0{margin:0}.pt-0{padding-top: 0px;}.mt-0{margin-top: 0px;}.py-1{padding-top: 0.25rem;padding-bottom: 0.25rem;}.px-3{padding-left: 0.75rem;padding-right: 0.75rem;}.w-2/4{width: 50%;}.mt-1{margin-top: 0.25rem;}.align-top{vertical-align: top;}p{margin:0}table{border-collapse: collapse;}table th, table td {border:1px solid #000;}.text-right{text-align:right}.flex-1{flex:1 1 0%}.w-40{width:10rem}.font-medium{font-weight:500}.py-1{padding-top:.25rem;padding-bottom:.25rem}.inline-block{display:inline-block}.mb-3{margin-bottom:.75rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.ml-auto{margin-left:auto}.border-black{border: 1px solid black;}.border{border-width:1px}.whitespace-no-wrap{white-space:nowrap}.text-center{text-align:center}.w-1/4{width: 25%}.text-left{text-align:left}.px-2{padding-left:.5rem;padding-right:.5rem}.min-w-full{min-width:100%}.mb-5{margin-bottom:1.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}body{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:1em}.justify-between{justify-content:space-between}.w-full{width:100%}.block{display:block}.flex{display:flex}.uppercase{text-transform: uppercase;}.mb-2{margin-bottom: 0.5rem;}.mb-3{margin-bottom: 0.75rem;}.font-bold{font-weight: 700;}.font-semibold{font-weight:600}.text-xl{font-size: 1.25rem;line-height: 1.75rem;}.size-m{font-size: 12px;font-weight: 500;}@media print {@page {size:  auto; margin: 0mm;}}</style>');
      mywindow.document.write('</head><body style="margin:5mm;margin-top:5mm;page-break-after: avoid; page-break-before: avoid;">');
      mywindow.document.write(document.getElementById("detailP").innerHTML);
      mywindow.document.write('</body></html>');
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/
      const self = this;
      setTimeout(function () {
        mywindow.print();
        mywindow.close();
        self.$vm2.close('nameInvoice');
      }, 500);
      return false;
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async getTotal(data) {
      this.total = 0;
      this.totalFees = 0;
      this.totalSales = 0;
      if (data && data.length) {
        data.forEach(item => {
          this.total += item.amount;
          this.totalFees += (item.confirmation_vat + item.fulfillement_fees_vat + item.shipping_vat);
          this.totalSales += item.order.totalPrice;
        });
      }
    },
    ProductNameSplit(data) {
      let product = "";
      for (let i in data) {
        if (data[i].name) product += data[i].name
        if (data.length - 1 != i) product += " |";
      }
      return product;
    },
    async dataToEdit() {
      if (this.$route.params.id || this.idP) {
        this.loading = true;
        if (this.idP) this.$store.dispatch("actionloadingemail", { loadingEmail: 'envoi' });
        this.dataProducts = [];
        const data = await this.$server.get("payments", { id: this.$route.params.id || this.idP, });

        if (data && data.content) {
          let finalExcuse = false;
          this.formData = data.content;
          this.formData.details = this.formData.details.sort((a, b) => (a.country > b.country) ? 1 : ((b.country > a.country) ? -1 : 0))
          this.expeditionCount = this.formData.expeditions.length;
         
          this.dataGroupedByCountry= _.chain(this.formData.details).groupBy("country").map((value, key) => ({ 
                country: key,currency:value[0].currency||null,
                count: value.length,
                orders: value,
                fees:value.map(item => item.confirmation_vat+item.fulfillement_fees_vat+item.shipping_cancel_vat+item.shipping_refund_vat+item.shipping_vat+(item.quality_control||0)+(item.upsell_vat||0)).reduce((prev, next) => prev + next),
                sales: value.map(item => item.affiliate && item.affiliate.type?item.affiliate.commission:item.POD && item.POD.name?item.POD.commission:item.order.totalPrice).reduce((prev, next) => prev + next), 
                amount:value.map(item => item.amount).reduce((prev, next) => prev + next) 
              })).value();
          this.dataGroupedExpeditionsByCountry = _.chain(this.formData.expeditions).groupBy("country").map((value, key) => ({ country: key, currency: value[0].currency || null, count: value.length, expeditions: value, fees: value.map(item => item.fees_amount).reduce((prev, next) => prev + next) })).value();
          this.dataGroupedRefundsByCountry = _.chain(this.formData.refunds).groupBy("country").map((value, key) => ({ country: key, currency: value[0].currency || null, count: value.length, refunds: value, fees: value.map(item => item.fees_amount).reduce((prev, next) => prev + next) })).value();
          this.dataGroupedChargesByCountry = _.chain(this.formData.charges).groupBy("country").map((value, key) => ({ country: key, currency: value[0].currency || null, count: value.length, charges: value, fees: value.map(item => item.fees_amount).reduce((prev, next) => prev + next) })).value();
          this.getTotal(this.formData.details);
          if (this.formData.details[0] && this.formData.details[0]) {}
          let iP = 0;

          for (const payment of this.formData.details) {
            let product = "";

            if (payment.order.details && payment.order.details[0] && !payment.order.details[0].name) {
              for (let i in payment.order.details) {

                if (payment.order.details[i] && payment.order.details[i].product) {
                  if (!this.dataProducts.find(o => o.id.toString() === payment.order.details[i].product.toString())) {
                    const editData = await this.$server.get("products", { id: payment.order.details[i].product, });
                    this.dataProducts.push({ id: payment.order.details[i].product.toString(), name: editData.content.name })
                  }
                  product += this.dataProducts.find(o => o.id.toString() === payment.order.details[i].product.toString()).name
                  if (payment.order.details.length - 1 != i) product += " | ";
                  payment.products = product;
                }

              }
            }

            iP++;
            if (iP === this.formData.details.length) finalExcuse = true;
          }
          if (this.formData.infoCurrency) {
            for (let i in this.formData.infoCurrency) {
              if (this.formData.infoCurrency[i].currency == 1) {
                const resW = await this.$server.get("warehouses", { country: this.formData.infoCurrency[i].country });
                const dataWahrhouse = await this.$server.get("settings", { warehouse: resW.content._id });
                if (dataWahrhouse.content.length > 0) {
                  const currentSettingW = this.getElementInArray(dataWahrhouse.content[0].details, resW.content._id);
                  this.formData.infoCurrency[i].currency = currentSettingW.info.currency;
                }
              }
            }
          } else {
            if (!this.formData.info || (this.formData.info && this.formData.info.currency == 1)) {
              const resW = await this.$server.get("warehouses", { country: this.formData.country });
              const dataWahrhouse = await this.$server.get("settings", { warehouse: resW.content._id });
              if (dataWahrhouse.content.length > 0) {
                const currentSettingW = this.getElementInArray(dataWahrhouse.content[0].details, resW.content._id);
                this.formData.info.currency = currentSettingW.info.currency;
              }
            }
          }
          if (this.formData.amountCurrency && this.formData.infoCurrency && this.formData.infoCurrency.length > 0 && this.formData.amountCurrency.length > 0) {
            this.formData.amountCurrency = this.sumObjAmountCurrency(this.formData.amountCurrency, this.formData.infoCurrency, this.formData.amountRefundsCurrency || [], this.formData.amountExpeditionsCurrency || [], this.formData.amountChargesCurrency || []);
            this.invoiceData.warehouses = "";
            this.formData.country.forEach(function (war, j) {
              this.invoiceData.warehouses += this.$f.getCountryNameByCode(this.options, war) + `${j != this.formData.country.length - 1 ? ', ' : ''}`;
            }.bind(this));
            this.invoiceData.sales = this.invoiceData.fees = this.invoiceData.amount = "";

            this.formData.amountCurrency.forEach(function (price, j) {
              this.invoiceData.sales += `${price.totalPrice.toFixed(2)} ${price.currency}${j != this.formData.amountCurrency.length - 1 ? '|' : ''}`;
              this.invoiceData.fees += `${price.fees.toFixed(2)} ${price.currency}${j != this.formData.amountCurrency.length - 1 ? '|' : ''}`;
              this.invoiceData.amount += `${price.amount.toFixed(2)} ${price.currency}${j != this.formData.amountCurrency.length - 1 ? '|' : ''}`;
            }.bind(this));

            this.invoiceData.mad = this.formData.amountCurrency.map(item => {
              const objC = this.formData.infoCurrency.find(o => o.currencyName === item.currency);
              return item.amount / objC.currency;
            }).reduce((prev, curr) => prev + curr, 0).toFixed(2);
          }

          this.loading = false;
          if (this.idP) {
            setTimeout(() => (this.$store.dispatch("actionloadingemail", { loadingEmail: 'final' })), 1300);
          }
        }
      }
    }
  },
};
</script>

<style scoped>
.login-or {
  position: relative;
  color: rgb(0 0 0 / 55%);
  ;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.hr-or {
  height: 2px;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  border: 0;
  border-top: 2px solid rgb(0 0 0 / 55%);
}

.span-or {
  display: block;
  position: absolute;
  left: 39%;
  top: -2px;
  background-color: #fff;
  width: 190px;
  text-align: center;
  font-weight: 700;
}

.invoice {
  display: flex;
}

.invoice-title {
  color: #999;
  font-size: 1.875rem;
  line-height: 2.25rem;
  margin-bottom: 0;
  font-weight: 700;
  text-transform: uppercase;
}

.invoice-des {
  text-align: right;
  margin-left: auto;
}

.invoice-logo {
  margin-left: auto;
  width: 10.5rem;
  height: auto;
  display: block;
  vertical-align: middle;
}

caption {
  background: #cdcdcd;
  font-weight: bold;
  font-size: 1.1em;
  margin-left: -1px;
  /* Fix FF 1px issue */
}

.w-40 {
  width: 25em;
}

.empty-row {
  background: repeating-linear-gradient(53deg, #bfc0c2 4%, #fcfcff 11px 6%, #ffffff 10px 7%, #9d9c9c 15px);
}

/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

table {
  max-width: 100%;
  overflow: scroll;
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
